import { Box, Card, Grid, Typography } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import { Link, useParams } from "react-router-dom";
import AnimatedLoader from "../../../components/Loader";
import axiosInstance from "../../../services/axiosInterceptors";
import { palette, theme as colorTheme} from "../../../Convoze.theme";
import ParentWrapper from "../../../components/ParentWrapper";


const primary = colorTheme('palette', 'primary').value;



const TranscriptDetails = () => {
  const token = localStorage.getItem("token");
  const [phases, setPhases] = useState([]);
  const [activeTab, setActiveTab] = useState(2);
  const [audioSrc, setAudioSrc] = useState("");
  const [currentTime, setCurrentTime] = useState(0);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [transcriptionId, setTranscriptionId] = useState("");

  const audioRef = useRef(null);
  const { id } = useParams();
  const transcriptContainerRef = useRef(null);
  const activeSentenceRef = useRef(null);

  useEffect(() => {
    getTranscriptDetails();
  }, []);

  useEffect(() => {
    if (buttonDisable) {
      const dataInterval = setInterval(() => {
        getTranscriptDetails();
      }, 5000);
      return () => clearInterval(dataInterval);
    }
  }, [buttonDisable]);

  const getTranscriptDetails = async () => {
    try {
      const res = await axiosInstance.get(
        `${apiEndPointsConfig?.demoTranscript}/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setTranscriptionId(res.data.data[0].transcriptionId);
      getData(res?.data?.data[0]?.transcriptionId);
      setPhases(res?.data?.data[0]?.phrases);
      const audioUrl = res?.data?.data[0]?.filePath;
      const baseURL = process.env.REACT_APP_BASE_API_URL;
      if (audioUrl) {
        setAudioSrc(`${baseURL}/${audioUrl}`);
      }
    } catch (error) {
      console.error("Error fetching transcript details:", error);
    }
  };

  const getData = async (id) => {
    try {
      const res = await axiosInstance.get(
        `${apiEndPointsConfig.interaction}/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res.data.data == null) {
        setButtonDisable(true);
      } else {
        setButtonDisable(false);
      }

    } catch (error) {
      return error;
    }
  };
  // Function to track current audio time
  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  // Scroll active sentence to the top
  useEffect(() => {
    if (activeSentenceRef.current && transcriptContainerRef.current) {
      transcriptContainerRef.current.scrollTo({
        top:
          activeSentenceRef.current.offsetTop -
          transcriptContainerRef.current.offsetTop,
        behavior: "smooth",
      });
    }
  }, [currentTime]);

  return (
    <ParentWrapper>
      <Box
      sx={{
        backgroundImage:
          "url('https://my.productfruits.com/new-web-dist/assets/onBoardingBackground.87827ee6.svg')",
        backgroundSize: "contained",
        backgroundPosition: "right center",
        backgroundRepeat: "no-repeat",
        width: "100%",
      }}
    >
      <Box>
        <Grid container>
          <Box
            sx={{
              p: 6,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Card
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                borderRadius: 3,
                p: 3,
                maxWidth: 600,
                border: "1px solid #e3e3e3",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <img
                    src={
                      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGkAAABpCAYAAAA5gg06AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAU1SURBVHgB7Z3NbhtVFMf/d+xILM2GbV0k1iRSQSA1rbNgTd8A9wFQ0hcgyRNAFqzj7JHaPkGmHwgokZIHQKr7BEQs8cflnGs7SvyViT1z5wz6/yQ7djxdND+fc8/9mHsBYh4HS5z6BurYxRBtWMGhO351IY8P8v4CfXnsuEtEwpak1/5YntuoAl5EOaTyeIltl6JA7EjSKKrhb1STrvwlOxJhJxJhXeSMJUlNkfQe1aeDAQ7zlJWA5E07fNk0desXLwcoqThU1jne+H2sCdNdHLqSAndWTYGMpDg0Q1S99m2sACXFoyGP41XSHyXFxuPgrqIoqQxU1KjjnglKKo921oiipDLJmPooqWxU1KlvLbuEkixQw/NloxOUZAMdXF5YSFCSHVpS8e3N+4CSbLEfpmymoCRbNMTITDRRkjUcdqejiZLsMRNNlGSRqWiiJJtoSd6evKEku3w7eUFJdmlNUh4lWaaGJ/qDkmzzWJ8oyTYtfaIk2zS1XaIk+zQpyTo1bFKSdTwjyT4O9yipAlBSBagjEuct3+j9i6ZzUvsnuKe51nts6mfyu6b7Ad0Hb1ypNxB887Pf/Ocj7P/x2ainb4VC/ygqpt+T0VwXBgtVSGPRtaJHJd2HAe7/4k/ffzLqSBqgU0gknW37JxIlu/2+/Edt3ZWbCRF0BJiRlF+6C1HTl8kqYE8ENVBlHC4lHdvA40Mukt5t+3avh31tW0DyRZqBtST99pVv1us4FtuVTGuVYIDuyiX4u4d+VwSdw1Du/p9ycedI0rZn0MOPviqbYlQZP9p55U6SNL1J23PKticSLmyVk33EQQXVahQUmVf6lEkSBZXEAKn+uFUSBZVGOtn3YakkLRIoqDROJi+WStIqjoJKwKOLR64zebuwutN+EMvsknCjtmjC3EjSdkgGEH4CKQfdiu0acyXJSMJzkHLws3vlzUjSwVKM5n5IbLQtGqIz/evZSBpi7f3ZyIq4+TtO3pCkUcRqrjQ61yu669yMJEZROfiwaeHhoo+vJDGKSsTh2bJdJa8kOY/vQOKj1dwj92LZJUGS9ovAybv4qKDH7uC2y4Kk2gYFRcfjKIsgJUhiqovMKIL2sl4+aZNaIHHImOKuU//z4fIN8UhOeFxKFfdUBL246z9NBp5DQBFIpQ+6dVsVt4h6wr5RcYyiR0vstWYUxBE+BymCzjh61p7y0Um/aq/btocezXMkIwgXyAmt7powgPdo6poKVBEfFvgfipyPJXKe5ilIMRVJ/UEY4H2GapCKmFeS0nRVT4oCiXanXyY89s62fWMo6WIwRLSDDaf5/i/g7NOrAxcvw+GLPhy6qKPVGiVxD16UfpKVO3EskX7x1u3ACLyxuQIk3l+FNTFK4lx5uZ9kQ9NdF8Q0idejoolpksmNSsQuyaB3c90xsUfy9e9hlQqLB8OEfpKU4S9BzJKMn1MQswRJGzXojCFTnlGCpK00DBamICa5PnZ3BGKSK0ky6puC0WSS6VHwQxBz3JDEaLLJvPkkRpMxZiRpNDkWEaaYOzNbq+OAk4F2mCtJ+01O1y0TEyxc4zAuItg+GWDpQhQRpWnvBKRUbl0ttLERDqblxGCJ3CpJ26d6HboGjaJKItO6O4oql8yLI1WUtFFb7EPF584rWB+8DTfksuqLyErLjLXq6/dxnx3eOKy8FlwXsEjltwVGVeGstWB/3E5Noor9qYLI5a4Kjaovf3VtyiqGXG99uSFLqsCqtll6KhoMUfiBOrqZxxBoJaPD1lswjpMvVm+AnfGiURP8BwDIlSd/wd8IAAAAAElFTkSuQmCC"
                    }
                    style={{ height: 22 }}
                    alt="Logo"
                  />
                  <Typography fontWeight={550}>
                    &nbsp;&nbsp;Speech Analytics
                  </Typography>
                </Box>
              </Box>
              <Typography color="grey">2 / 2</Typography>
              <Typography
                variant="h6"
                sx={{
                  mt: 1,
                  color: "grey",
                  display: "flex",
                  alignItems: "center",
                  color: primary,
                  fontWeight: 550,
                  textDecoration: "capatalize",
                }}
              >
                &nbsp; Voice Conversation Summary
              </Typography>
              <Typography
                color="grey"
                variant="body2"
                mt={0}
                textAlign={"Center"}
              >
                This summary provides an overview of the main points discussed
                in <br /> the audio.
              </Typography>
              <Grid item md={10} xs={12} container sx={{ mt: 2 }}>
                <Grid
                  item
                  xs={12}
                  md={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      border: "1px dotted rgb(209, 209, 209)",
                      borderRadius: 6,
                      overflow: "hidden",
                      width: "100%",
                    }}
                  >
                    <Box
                      ref={transcriptContainerRef}
                      sx={{
                        height: 400,
                        overflow: "auto",
                        width: { xs: "90%", md: "100%" },
                        p: {
                          xs: 3,
                          md: 0,
                        },
                        "&::-webkit-scrollbar": { width: "0px" },
                      }}
                    >
                      {phases.length > 0 ? (
                        phases.map((e, i) => {
                          const isActive =
                            currentTime >= e.offset &&
                            (i === phases.length - 1 ||
                              currentTime < phases[i + 1]?.offset);

                          return (
                            <Box
                              key={i}
                              sx={{ mt: 1, mb: 4, pt: 2 }}
                              ref={isActive ? activeSentenceRef : null}
                            >
                              <Grid
                                item
                                xs={12}
                                md={12}
                                sx={{
                                  display: {
                                    xs:
                                      e?.channel === 1 ? "initial" : "initial",
                                    md: e?.channel === 1 ? "initial" : "flex",
                                  },
                                  justifyContent:
                                    e?.channel === 1
                                      ? "flex-start"
                                      : "flex-end",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: "grey",
                                    display: "flex",
                                    alignItems: "center",
                                    p: {
                                      xs: e?.channel === 1 ? "0 0px" : "0 0px",
                                      md:
                                        e?.channel === 1
                                          ? "0px 25px"
                                          : "0 25px",
                                    },
                                  }}
                                >
                                  <img
                                    src={
                                      e?.channel === 1
                                        ? "https://urbanpiper.zuqo.app/assets/svgs/customer_conversation.svg"
                                        : "https://urbanpiper.zuqo.app/assets/svgs/agent_conversation.svg"
                                    }
                                    alt={
                                      e?.channel === 1 ? "Customer" : "Agent"
                                    }
                                    style={{
                                      width: 30,
                                      borderRadius: "50%",
                                    }}
                                  />
                                  &nbsp;&nbsp;{" "}
                                  {e?.channel === 1 ? "Customer" : "Agent"}{" "}
                                  &nbsp;&nbsp;
                                  {e.offset} sec
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                xs={12}
                                md={12}
                                sx={{
                                  display: {
                                    xs:
                                      e?.channel === 1 ? "initial" : "initial",
                                    md: e?.channel === 1 ? "flex" : "flex",
                                  },
                                  justifyContent:
                                    e?.channel === 1
                                      ? "flex-start"
                                      : "flex-end",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{
                                    textAlign: {
                                      xs: e?.channel === 1 ? "left" : "left",
                                      md: e?.channel === 1 ? "left" : "right",
                                    },
                                    color: isActive ? "red" : "#3c3e42",
                                    fontWeight: 500,
                                    mt: 1,
                                    p: { xs: "0px", md: "10px 30px" },
                                    bgcolor: {
                                      xs: e?.channel === 1 ? "" : "",
                                      md:
                                        e?.channel === 1
                                          ? "#f7f7f7"
                                          : "#d9fdd3",
                                    },
                                    borderRadius:
                                      e?.channel === 1
                                        ? "0 12px 12px 0"
                                        : "12px 0 0 12px",
                                  }}
                                >
                                  {e.text}
                                </Typography>
                              </Grid>
                            </Box>
                          );
                        })
                      ) : (
                        <Typography sx={{ color: "grey", mt: 2 }}>
                          No transcription data available.
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  {/* Audio Player */}
                  <Box sx={{ mt: 3, width: { xs: "90%", md: "95%" } }}>
                    {audioSrc ? (
                      <audio
                        ref={audioRef}
                        controls
                        onTimeUpdate={handleTimeUpdate}
                        style={{ width: "100%" }}
                      >
                        <source src={audioSrc} type="audio/mpeg" />
                        Your browser does not support the audio element.
                      </audio>
                    ) : (
                      <Typography sx={{ mt: 3, color: "red" }}>
                        Audio not available
                      </Typography>
                    )}
                  </Box>
                  {buttonDisable == true ? (
                    <Box
                      onClick={() =>
                        alert("Please wait till we get the insights ready!")
                      }
                      sx={{
                        color: "grey",
                        // textDecoration: "none",
                        textAlign: "right",
                        // width: "100%",
                        marginTop: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <AnimatedLoader />
                    </Box>
                  ) : (
                    <Link
                      to={`/user/audio-analytics/${transcriptionId}`}
                      style={{
                        color: primary,
                        // textDecoration: "none",
                        textAlign: "center",
                        width: "100%",
                        marginTop: "10px",
                      }}
                    >
                      see audio analytics
                    </Link>
                  )}
                </Grid>
              </Grid>
            </Card>
          </Box>
        </Grid>
      </Box>
    </Box>
    </ParentWrapper>
  );
};

export default TranscriptDetails;
